import React from "react";

import { Container, Row, Col } from "reactstrap";
import Button from "@material/react-button";
import MaterialIcon from "@material/react-material-icon";
import GitHub from "react-ionicons/lib/LogoGithub";
import CV from "./CV";
import Ribbon from "react-ionicons/lib/MdRibbon";
import { withRouter, Link } from "react-router-dom";

class Footer extends React.Component {
  state = { creditsOpen: false };

  render() {
    return (
      <div className="footer">
        <Container>
          <Row className="d-flex align-items-center">
            <Col xs={12} sm={6} className="py-0">
              <Link to="/contact">
                <Button icon={<MaterialIcon icon="mail" />}>Contact me</Button>
              </Link>
              <ul className="mb-0">
                <li>
                  <Button
                    href={require("../assets/cv/roman-rieunier-resume.pdf")}
                    target="_blank"
                    icon={<CV />}
                  >
                    My resume
                  </Button>
                </li>
                <li>
                  <Button
                    href="https://github.com/Moccko"
                    target="_blank"
                    icon={<GitHub />}
                  >
                    GitHub repository
                  </Button>
                </li>
                <Link to="/credits">
                  <Button icon={<Ribbon />}>Credits</Button>
                </Link>
              </ul>
            </Col>
            <Col xs={12} sm={6} className="pt-1">
              <div
                className="LI-profile-badge"
                data-version="v1"
                data-size="medium"
                data-locale={navigator.language.replace("-", "_")}
                data-type="horizontal"
                data-theme="dark"
                data-vanity="rrieunier"
              >
                <a
                  className="LI-simple-link"
                  href="https://www.linkedin.com/in/rrieunier?trk=profile-badge"
                >
                  Roman Rieunier
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

Footer.propTypes = {};

export default withRouter(Footer);
